import { render, staticRenderFns } from "./lojaPerfeitaCriterionModal.vue?vue&type=template&id=333db440&scoped=true&"
import script from "./lojaPerfeitaCriterionModal.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaCriterionModal.vue?vue&type=script&lang=js&"
import style0 from "./lojaPerfeitaCriterionModal.vue?vue&type=style&index=0&id=333db440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333db440",
  null
  
)

export default component.exports